module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.963eb329.woff";